import { render, staticRenderFns } from "./importerAddress.vue?vue&type=template&id=4e4f6cc3&scoped=true"
import script from "./importerAddress.vue?vue&type=script&lang=js"
export * from "./importerAddress.vue?vue&type=script&lang=js"
import style0 from "./importerAddress.vue?vue&type=style&index=0&id=4e4f6cc3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4f6cc3",
  null
  
)

export default component.exports